module.exports = "<div class=\"text-digital-red\">\r\n  <h2>Error</h2>\r\n  <p>There was a problem submitting the form, please try again later.</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/cigna-frontend/js/views/autovalidate-default-error-msg.tpl.html
// module id = ii/L
// module chunks = 4